<template>
    <div v-cloak>
        <div>
            <div
                :class="{
                    'is-current': t.is_current,
                    'events-group-item cursor-pointer': true,
                    done: t.status === 'done'
                }"
                @click="goToTask(t)"
            >
                <div>
                    <div class="events-group-item-header">
                        {{ t.name }}
                    </div>
                    <div class="events-group-item-content" v-if="t.time">
                        <div :class="{ 'events-group-item-content--date': true, red: isToday(t.time) }">
                            <span v-if="!isToday(t.time)">
                                {{ moment(t.time).format("dd")[0] }}
                                {{ moment(t.time).format("DD.MM, HH:mm") }}
                            </span>
                            <span v-else> Today, {{ moment(t.time).format("HH:mm") }} </span>
                        </div>
                    </div>
                </div>
                <div class="status-container">
                    <div class="status">{{ t.related_event }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import router from "@/router";

export default {
    props: ["t", "i"],
    data() {
        return {};
    },
    computed: {},
    methods: {
        goToTask(task) {
            router.push({ path: "/events/" + task.event_id + "/tasks/" + task.id });
        },
        isToday(date) {
            let today = moment().format("DD.MM.YYYY");
            let fdate = moment(date).format("DD.MM.YYYY");
            if (today === fdate) {
                return true;
            } else {
                return false;
            }
        },
        getElementId(m) {
            return m.is_current ? "is-current" : "";
        },
        getDate(date) {
            let time_date = moment(date, "MM.YYYY");
            return moment(time_date).format("MMMM YYYY");
        }
    }
};
</script>
<style scoped>
[v-cloak] {
    display: none;
}

.events-group-item {
    display: flex;
    flex-direction: row;
    padding: 0.8rem 0;
}

.events-group-item-header {
    font-size: 1.2rem;
    line-height: 2.4rem;
    letter-spacing: 0.03em;
}

.done .events-group-item-content,
.done .events-group-item-header {
    opacity: 0.4;
}

.events-group-item-content {
    font-size: 1.1rem;
    line-height: 1.6rem;
    letter-spacing: 0.05em;
}
.cursor-pointer {
    cursor: pointer;
}
.status-container {
    margin-left: auto;
}
.status {
    margin-top: 0.4rem;
    text-align: right;
    flex-wrap: wrap;
    color: #9d9d9d;
    width: 16rem;
    font-size: 1.1rem;
    line-height: 1.6rem;
    margin-right: 0.8rem;
    letter-spacing: 0.05em;
}
</style>
